import React, { Component } from "react";
import { connect } from "react-redux";
import { logger } from "../../helper/Logger";
import { IConfigProps, IRootState } from "../../interfaces";
import { AppRoutes } from "../../config";
import { ImageURL } from "../../config";
import { FrontendUrl, getEnvValue } from "../../config";
import { configReducer } from "../../reducer/Configuration";
import { Block } from "@material-ui/icons";

interface menus {
  path: any;
  name: any;
  id: any;
  src: any;
}

class Sidebar extends Component<any> {
  state = {
    showResourcesOptions: false,
    backgroundColorResourceItem: "none",
  };
  normalLeftSpace = () => {
    document
        .getElementById("menu-hover-info")
        ?.setAttribute("style", "width: 50px;");

    let menuTextElement = document.getElementsByClassName("parentMenu");

    for(var j=0;j<menuTextElement.length; j++) {
      menuTextElement[j].setAttribute("class","parentMenu menuText invisibleMenu");
    }
    let submenuItem = document.getElementsByClassName("sub-menu-items");

    for(var j=0;j<submenuItem.length; j++) {
      let subMenuMatches = document.querySelectorAll("div#menu-hover-info div.ITEMS_CONTAINER div.cursor-pointer div.profile-text");
      submenuItem[j]?.setAttribute("style","display:none");
      subMenuMatches[j].setAttribute("style","height:25px");
      document.getElementById("arrowDown"+j)?.setAttribute("class", "fa fa-angle-down");
    }
    
  };
  changeLeftSpace = () => {
    let menuTextElement = document.getElementsByClassName("parentMenu");

    for(var j=0;j<menuTextElement.length; j++) {
      menuTextElement[j].setAttribute("class","parentMenu menuText visibleMenu");
    }

    document
        .getElementById("menu-hover-info")
        ?.setAttribute("style", "width: 165px;");
  };
  highlightMenu = (divId: any) => {
    var highlight = document.getElementById(divId);
    if (highlight) {
      highlight.style.textDecoration = "underline";
    }
    document.getElementsByClassName("right-side-container")[0].setAttribute("style","padding-left:170px");
  };
  deHighlightMenu = (divId: any) => {
    var deHighlight = document.getElementById(divId);
    if (deHighlight) {
      deHighlight.style.textDecoration = "";
    }
    document.getElementsByClassName("right-side-container")[0].removeAttribute("style");
  };

  openSubMenu = (id: any, subMenus: any, isMObile: any) => {
  var subMenuStr: any;
  let leftsubmenuItems: menus[];

  leftsubmenuItems = subMenus;
  //console.log(typeof(leftsubmenuItems));
  if(leftsubmenuItems && leftsubmenuItems.length > 0) {
    subMenuStr = leftsubmenuItems.map((subMenuItem: any, index1: any) =>
    subMenuItem.environment.split(",").includes(getEnvValue()) ? (
    <>
    <div
      className={`menuText subMenuClass subMenuText${id}`}
      id={`${subMenuItem.id}${isMObile}`}
    >
      <img
      className="menu_item noselect"
      style={{ verticalAlign: "middle", float: "left" }}
      height="28px"
      width="28px"
      src={`${FrontendUrl}${subMenuItem.src}`}
      alt={subMenuItem.name}
    /><span style={{paddingLeft: "5px" }} onClick={() => this.redirectToPage(subMenuItem.path)} className="noselect">
        {subMenuItem.name}</span>
  </div>    
    
    </>) : ("")

       ); 
  }
       
return  subMenuStr; }

  redirectToPage = (path: any) => {
    if (path == "quiz") {
      this.props.history.push({
        pathname: AppRoutes.START_QUIZ,
        state: {
          defaultActiveKey: "notStartedCourses",
        },
      });
    } else if (path == "editProfile") {
      this.props.history.push(AppRoutes.MY_ACCOUNT);
    } else if (path == "resources") {
      this.setState({
        showResourcesOptions: !this.state.showResourcesOptions,
      });
      this.props.history.push({
        pathname: AppRoutes.RESOURCES,
        state: {
          defaultActiveKey: "notStartedCourses",
        },
      });
    } else {
      window.location.href = "/student" + path;
    }
  };
  componentDidUpdate = (prevProps: IConfigProps) => {
    if (document.getElementById("menu-hover-info")) {
      let matches = document.querySelectorAll(
        "div#menu-hover-info div.ITEMS_CONTAINER div.cursor-pointer div.profile-text img.menu_item"
      );
      if (matches.length === 6) {
        matches.forEach((ImgItem, index) => {
          if (index === 2) ImgItem.setAttribute("height", "20px");
        });
      }
    }
    const { configReducer } = this.props;
    if (
      prevProps.configReducer &&
      configReducer &&
      configReducer.isLoading !== prevProps.configReducer.isLoading
    ) {
      this.setState({
        configInfo: configReducer.configInfo,
      });
    }
  };

  createMenus(permissions: any, isMObile: any) {
    const { configInfo } = permissions;
    var str;
    //console.log("permi",configInfo);
    if (configInfo) {
      //console.log("Objj--",typeof(configInfo));
      Object.keys(configInfo).map((key) => {
        //console.log("config env--",configInfo.environment);
        if (configInfo.value && configInfo.name === "portalMenus") {
          let leftmenuItems: menus[];

          leftmenuItems = JSON.parse(configInfo.value);

          str = leftmenuItems.map((item: any, index: any) =>
            item.environment.split(",").includes(getEnvValue()) ? (
              <div
                style={{
                  maxWidth: "165px",
                  display: "flex",
                  alignItems: "center",
                }}
                className={`cursor-pointer  ${
                  this.props.location.pathname === item.path ? "active" : ""
                }`}
                onMouseEnter={() => this.highlightMenu(item.id)}
                onMouseLeave={() => this.deHighlightMenu(item.id)}
                onPointerOver={() => this.highlightMenu(item.id)}
              >
                <div
                  className="profile-text firstImage"
                  style={{ textAlign: "center", width: "100%" }}
                >
                  <div className="each-menu-item">
                    <div>
                      <img
                        className="menu_item"
                        style={{ verticalAlign: "middle", float: "left" }}
                        height="28px"
                        width="28px"
                        src={`${FrontendUrl}${item.src}`}
                        alt={item.name}
                      />
                    </div>
                    <div
                      className="parentMenu menuText invisibleMenu"                    
                      id={`${item.id}${isMObile}`}
                    >
                          
                          {item.parent === true ? (
                            <>
                            <div className="menuTextShow" style={{paddingLeft: "5px", minWidth: "90px" }} >{item.name}
                          </div>
                            <div style={{float: "right"}}>
                              <i id={`arrowDown${index}`} className="fa fa-angle-down" style={{fontSize:"16px",color:"#FFF",paddingLeft:"5px"}} 
                              onClick={(e) => {
                                //change the menus height based on submenus
                                let subMenuMatches = document.querySelectorAll("div#menu-hover-info div.ITEMS_CONTAINER div.cursor-pointer div.profile-text");
                                //console.log("subMenuMatches.length",subMenuMatches.length)
                                let subMenuElements = document.getElementsByClassName(
                                  "subMenuText"+index
                                );
                                //console.log("subMenuElements",subMenuElements.length)
                                var initialHeight = 25;                          
                                console.log("click arrow for submenu");
                                var element = document.getElementById(`subMenu${index}`);
                                if(element) {
                                  var subMenuStyle = element.getAttribute("style");
                                  if(subMenuStyle === "display:block") {
                                    element.setAttribute("style","display:none");
                                    subMenuMatches[index].setAttribute("style","height:"+initialHeight+"px");
                                    document.getElementById("arrowDown"+index)?.setAttribute("class", "fa fa-angle-down");
                                  } else {
                                    var calculatedHeight = initialHeight + (initialHeight * subMenuElements.length) + 25;
                                    subMenuMatches[index].setAttribute("style","height:"+calculatedHeight+"px");
                                    element.setAttribute("style","display:block");
                                    document.getElementById("arrowDown"+index)?.setAttribute("class", "fa fa-angle-up");
                                  }                            
                                }
                            }}></i></div>           
                              </>) : 
                          <div className="menuTextShow" style={{paddingLeft: "5px", minWidth: "90px" }} onClick={() => this.redirectToPage(item.path)}>{item.name}
                          </div>}  
                      </div>
                  </div>
                  
                  <div id={`subMenu${index}`} style={{display: "none"}} className="sub-menu-items"> 
                  {this.openSubMenu(index, item.subMenus, isMObile)}  
                  </div>
                  </div>
              </div>
            ) : (
              ""
            )
          );
        }
      });
    }
    return str;
  }

  render() {
    const {
      profileReducer,
      activeKey,
      mobileView,
      mobileClass,
      configReducer,
    } = this.props;

    const { profileInfo } = profileReducer;
    const { configInfo } = configReducer;

    console.log("mobileView", mobileView);
    const immm = window.location.href;
    const samm = immm.split("/").splice(0, 3);
    const imgPath = FrontendUrl + "uploads/" + profileInfo.imagePath;
    console.log("dirrrrrrrrrrrrr", imgPath);
    logger(this.props.profileReducer);
    //console.log("config data",configInfo);
    //this.props.setUserImage(profileInfo.imagePath);

    return (
        <div
          style={{ marginTop: mobileView ? "54px" : "" }}
          id="menu-hover-info"
          className={`menu-hover-info custom-sidebar menu-hover-info-hide`}
          onMouseEnter={() => this.changeLeftSpace()}
          onMouseLeave={() => this.normalLeftSpace()}
        >
          <div className="ITEMS_CONTAINER">
            {this.createMenus(configReducer, "")}
          </div>
        </div>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  profileReducer: state.profileReducer,
  configReducer: state.configReducer,
});

export default connect(mapStateToProps)(Sidebar);
